import React from 'react';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
const CardSkeltonPlay = () => {
    return (
        <div className='shadow-xl'>
            <SkeletonTheme baseColor="#10171E" highlightColor="#15202B">
                <Skeleton height={300} width={900} />
            </SkeletonTheme>
        </div>
    );
};

export default CardSkeltonPlay;